import React from 'react';

export default class BbRadio extends React.Component {
    render() { return (
        <span ref={el => this.radio = el ? el : this.radio} style={{ width: '1.25em', height: '1.25em', minWidth: '1.25em', minHeight: '1.25em' }}>
            <span style={{ width: '.75em', height: '.75em', top: '.25em', left: '.25em' }} />
        </span>
    )}
}